import React from 'react';
import SortableTh from '@/client/components/common/SortableTh';
import { Skeleton } from '@/components/ui/skeleton';
import { TooltipProvider } from '@/components/ui/tooltip';
import type { EntityStatus } from '@/client/api/listing-management/entity.mutation';
import { ListingTableRow } from './ListingTableRow';

const LoadingRow: React.FC = () => (
  <tr className="hover:bg-gray-50">
    <td className="px-6 py-4 whitespace-nowrap">
      <div className="flex items-center">
        <div className="flex-shrink-0 h-12 w-16">
          <Skeleton className="h-12 w-16 rounded" />
        </div>
        <div className="ml-4 space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
    </td>
    <td className="px-6 py-4 whitespace-nowrap"><Skeleton className="h-4 w-20" /></td>
    <td className="px-6 py-4"><Skeleton className="h-4 w-40" /></td>
    <td className="px-6 py-4 whitespace-nowrap"><Skeleton className="h-4 w-16" /></td>
    <td className="px-6 py-4 whitespace-nowrap"><Skeleton className="h-4 w-20" /></td>
    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"><Skeleton className="h-4 w-16 ml-auto" /></td>
  </tr>
);

export const ListingTableView: React.FC<{
  entities: any[];
  loading: boolean;
  limit: number;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onToggleSort: (field: string) => void;
  onOpenDetail: (eid: number) => void;
  onAct: (entity: any, next: EntityStatus, label: string) => void;
}> = ({ entities, loading, limit, sortBy, sortOrder, onToggleSort, onOpenDetail, onAct }) => (
  <TooltipProvider delayDuration={200}>
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <SortableTh label="Entity" field="name" sortBy={sortBy} sortOrder={sortOrder} onToggle={onToggleSort} />
            <SortableTh label="Type" field="type" sortBy={sortBy} sortOrder={sortOrder} onToggle={onToggleSort} />
            <SortableTh label="Price" field="price" sortBy={sortBy} sortOrder={sortOrder} onToggle={onToggleSort} />
            <SortableTh label="Status" field="status" sortBy={sortBy} sortOrder={sortOrder} onToggle={onToggleSort} />
            <SortableTh label="Created" field="date_added" sortBy={sortBy} sortOrder={sortOrder} onToggle={onToggleSort} />
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading
            ? Array.from({ length: limit }).map((_, i) => <LoadingRow key={i} />)
            : entities.map((row) => (
                <ListingTableRow key={row.Entity.eid} row={row} onOpenDetail={onOpenDetail} onAct={onAct} />
              ))}
        </tbody>
      </table>
    </div>
  </TooltipProvider>
);
